import React from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons";
import { Select } from "../../form/select";
import { Main } from "./style";
import { webURL } from "../../../services/API";

interface itemType { id: string, name: string, info: any, isActive: boolean };

function getConnectionTypeAliases(type: string): string[] {
   if (type === "instagramMsgs") return ["instagramMsgs", "instagram"];
   if (type === "instagramPosting") return ["instagramPosting", "instagram"];
   return [type];
}

export function AuthenticateSelect(
   { type, defaultId, handleAuthenticate, withLine, background }: 
   { type: string, defaultId: string, handleAuthenticate: (type: 'add' | 'remove', data?: any) => void, withLine?: boolean, background?: string }
) {
   const [isLoading, setIsLoading] = React.useState<boolean>(false);
   const [items, setItems] = React.useState<itemType[]>([]);

   // eslint-disable-next-line react-hooks/exhaustive-deps
   React.useEffect(() => { getConnections() }, []);

   // ---
   React.useEffect(() => {
      setItems(prev => prev.map(item => ({ ...item, isActive: item.id === defaultId })));
   }, [defaultId]);

   // ---
   const getConnections = async () => {
      setIsLoading(true);
      const aliases = getConnectionTypeAliases(type);
      const responses = await Promise.all(
         aliases.map((name) => axios.get(`${webURL}/connections?byName=${name}`))
      );
      const mergedData = responses
         .flatMap((response) => (Array.isArray(response.data) ? response.data : []))
         .filter((item, index, self) => self.findIndex((i: any) => i._id === item._id) === index);
      const update: itemType[] = mergedData.map((item: any, index: number) => ({ 
         id: item._id, name: item.description || 'Connection '+(index+1), info: item.info, isActive: item._id === defaultId 
      }));
      setItems(update);
      if (defaultId && !update.some(item => item.id === defaultId)) {
         handleAuthenticate('remove');
      }
      setIsLoading(false);
   }

   // ---
   const handleSelectConnection = (id: string) => {
      const data = items.map(item => ({ ...item, isActive: item.id === id }));
      setItems(data);
      const find = data.find(item => item.isActive);
      handleAuthenticate('add', { id: find?.id, ...find?.info });
   }

   return (
      <Main className={`authSelect ${withLine ? 'withLine' : ''}`}>
         <Select data={ items } emptyMsg="There is no connection" handleSelectItem={ handleSelectConnection } isSmall={ true } />
         <button className="btn1" onClick={ getConnections } disabled={ isLoading } style={{ background: background || '#3E82F8' }}>
            <FontAwesomeIcon icon={ faArrowRotateRight } />
         </button>
         <button className="btn1" onClick={ _=> window.open('/connections', '_blank') } style={{ background: background || '#3E82F8' }}>Add new</button>
      </Main>
   );
}